import {useState} from "react";
import { useTranslator } from "../../context/TranslatorContext";
import {Typography, Button} from "@mui/material";

export default function ExpandableText({text, maxLength = 150}) {
  const [expanded, setExpanded] = useState(false);
  const {messages} = useTranslator();
  if (!text) return null;

  const isLong = text.length > maxLength;
  const displayText = expanded || !isLong ? text : text.slice(0, maxLength) + "...";

  return (
    <>
      <Typography variant="body1" style={{textAlign: "justify"}}>
        {displayText}
      </Typography>
      {isLong && (
        <Button size="small" onClick={() => setExpanded(!expanded)}>
          {expanded ? messages.landing_page_hide_text : messages.landing_page_show_text}
        </Button>
      )}
    </>
  );
}
